import backArrowIcon from '@icons/backArrow.svg';
import closeIcon from '@icons/closeIcon.svg';
import closeModalIcon from '@icons/closeModal.svg';
import priceReducedIcon from '@icons/priceReducedIcon.svg';
import callForPriceCommunityIcon from '@icons/dynamic/callForPriceCommunityIcon.svg';
import callForPriceHomeIcon from '@icons/dynamic/callForPriceHomeIcon.svg';
import thanksContentIcon from '@icons/thanksContent.svg';
import locationIcon from '@icons/location.svg';
import interactiveSitePlanIcon from '@icons/interactiveSitePlan.svg';
import visibilityOffIcon from '@icons/dynamic/visibilityOff.svg';
import visibilityIcon from '@icons/dynamic/visibility.svg';

// modal icons
import thankYouHeart from '@icons/modal/thankYouHeart.svg';
import thankYouEmail from '@icons/modal/thankYouEmail.svg';
import thankYouPhone from '@icons/modal/thankYouPhone.svg';
import thankYouSuccess from '@icons/modal/thankYouSuccess.svg';
import thankYouLoader from '@icons/modal/thankYouLoader.svg';

// toast icons
import circleCheck from '@icons/circleCheck.svg';
import circleWarning from '@icons/circleWarning.svg';

// these are static icons, webpack will return the path to the file instead of the icon itself
export const backArrowSvg = `<img src="${backArrowIcon}" />`;
export const closeIconSvg = `<img src="${closeIcon}" />`;
export const closeModalIconSvg = `<img src="${closeModalIcon}" />`;
export const priceReducedIconSvg = `<img src="${priceReducedIcon}" alt="Price Reduced" />`;
export const thanksContentIconSvg = `<img class="builder__icon" src="${thanksContentIcon}" />`;
export const locationIconSvg = `<img src="${locationIcon}" />`;
export const interactiveSitePlanSvg = `<img src="${interactiveSitePlanIcon}" />`;

export const thankYouHeartSvg = `<img src="${thankYouHeart}" />`;
export const thankYouEmailSvg = `<img src="${thankYouEmail}" />`;
export const thankYouPhoneSvg = `<img src="${thankYouPhone}" />`;
export const thankYouSuccessSvg = `<img class="builder__icon success__icon" height="100" src="${thankYouSuccess}" />`;
export const thankYouLoaderSvg = `<img class="brochure-download__spin-icon--spin" src="${thankYouLoader}" />`;

// These are dynamic icons, these are served as svg-in-js and are included in the .js bundle
// you should only consider using dynamic icons if you need to change the color or any other
// attribute of the icon itself.
export const callForPriceCommunityIconSvg = callForPriceCommunityIcon;
export const callForPriceHomeIconSvg = callForPriceHomeIcon;
// 
export const visibilityOffIconSvg = visibilityOffIcon;
export const visibilityIconSvg = visibilityIcon;

export const circleCheckSvg = `<img src="${circleCheck}" />`;
export const circleWarningSvg = `<img src="${circleWarning}" />`;
